import Vue from 'vue';
import { post, get, upfile } from './request';
import url from './url'
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$upfile = upfile;
Vue.prototype.url = url.url;